var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectIconDis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.295 6.788h4.083a2.23 2.23 0 0 1 2.228 2.227v1.231l-10.338 3.181a.186.186 0 0 1-.111 0l-10.339-3.18V9.014a2.23 2.23 0 0 1 2.227-2.227h4.084v-.742a2.23 2.23 0 0 1 2.227-2.228h3.712a2.23 2.23 0 0 1 2.227 2.228v.742zm-6.682-.742v.742h5.197v-.742a.743.743 0 0 0-.742-.743h-3.712a.743.743 0 0 0-.742.743zm12.993 5.753-9.903 3.047c-.32.1-.662.1-.982 0L3.818 11.8v3.898H5.33 3.82v3.712a2.23 2.23 0 0 0 2.226 2.227H22.378a2.23 2.23 0 0 0 2.228-2.227V15.697h-1.511H24.606v-3.898z",
    fill: "#ABABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIconDis);
export default __webpack_public_path__ + "static/media/projectIcon-dis.906e52f8d42c73dd139cafcfa3090774.svg";
export { ForwardRef as ReactComponent };